import axios from 'axios'
import config from '../config'

export default {
  request (method, uri, data = null) {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    const url = config.serverURI + uri
    return axios({ method, url, data })
  },

  authenticatedRequest (method, uri, data = null) {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    const url = config.serverURI + uri
    const headers = { 'Authorization': window.localStorage.getItem('token') }
    return axios({ method, url, data, headers })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js